module.exports = __webpack_public_path__ + "img/album20_02.ccd9a187.jpg";